import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Row,
    Col,
    Alert
} from 'reactstrap'

import api from '../api'
import NotificationService from '../../../services/NotificationService.js'

import './TenantForm.scss'

class TenantsForm extends Component {

    static propTypes = {
        tenant: PropTypes.object,
        onCancel: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        const { tenant } = props
        
        this.state = {
            identifier: tenant ? tenant.identifier : '',
            description: tenant ? tenant.description : '',
            tenantId: tenant ? tenant.tenantId : '',
            loading: false,
            errors: {}
        }
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
            errors: {
                ...this.state.errors,
                [e.target.name]: null
            }
        })
    }

    validateForm = () => {
        const { identifier, description, tenantId } = this.state
        const errors = {}
        
        if (!identifier) {
            errors.identifier = 'Identifier is verplicht'
        } else if (identifier.length > 4) {
            errors.identifier = 'Identifier mag maximaal 4 tekens bevatten'
        }
        
        if (!description) {
            errors.description = 'Beschrijving is verplicht'
        }
        
        // TenantId is optional, but if provided should be a valid GUID
        if (tenantId && !this.isValidGuid(tenantId)) {
            errors.tenantId = 'TenantId moet een geldig GUID-formaat zijn'
        }
        
        this.setState({ errors })
        
        return Object.keys(errors).length === 0
    }
    
    isValidGuid = guid => {
        const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
        return guidRegex.test(guid)
    }

    handleSubmit = async e => {
        e.preventDefault()
        
        if (!this.validateForm()) {
            return
        }
        
        const { tenant } = this.props
        const { identifier, description, tenantId } = this.state
        
        this.setState({ loading: true })
        
        try {
            if (tenant) {
                // Update existing tenant
                await api.updateTenant(tenant.id, {
                    identifier,
                    description,
                    tenantId: tenantId || null
                })
                NotificationService.notifySuccess({
                    title: 'Succes',
                    message: `Tenant "${description}" is bijgewerkt.`
                })
            } else {
                // Create new tenant
                await api.createTenant({
                    identifier,
                    description,
                    tenantId: tenantId || null
                })
                NotificationService.notifySuccess({
                    title: 'Succes',
                    message: `Tenant "${description}" is aangemaakt.`
                })
            }
            
            this.setState({ loading: false })
            this.props.onCancel() // Return to list view
        } catch (err) {
            this.setState({ 
                loading: false,
                error: err.message
            })
            NotificationService.notifyError({
                title: err.message || 'Fout',
                message: 'Er is een fout opgetreden tijdens het opslaan van de tenant.'
            })
        }
    }

    render() {
        const { tenant, onCancel } = this.props
        const { identifier, description, tenantId, loading, errors, error } = this.state
        
        return (
            <div className="tenant-form">
                <h3>{tenant ? 'Tenant bewerken' : 'Nieuwe tenant toevoegen'}</h3>
                
                {error && (
                    <Alert color="danger">
                        {error}
                    </Alert>
                )}
                
                <Form onSubmit= { this.handleSubmit }>
                    <Row>
                        <Col md= { 6 }>
                            <FormGroup>
                                <Label for="identifier">Identifier (Max. 4 tekens)</Label>
                                <Input
                                    type="text"
                                    name="identifier"
                                    id="identifier"
                                    value= { identifier }
                                    onChange= { this.handleChange }
                                    maxLength= { 4 }
                                    invalid= { !!errors.identifier }
                                />
                                {errors.identifier && (
                                    <div className="text-danger">{errors.identifier}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md= { 6 }>
                            <FormGroup>
                                <Label for="description">Beschrijving</Label>
                                <Input
                                    type="text"
                                    name="description"
                                    id="description"
                                    value= { description }
                                    onChange= { this.handleChange }
                                    invalid= { !!errors.description }
                                />
                                {errors.description && (
                                    <div className="text-danger">{errors.description}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md= { 6 }>
                            <FormGroup>
                                <Label for="tenantId">Tenant ID (GUID)</Label>
                                <Input
                                    type="text"
                                    name="tenantId"
                                    id="tenantId"
                                    value= { tenantId }
                                    onChange= { this.handleChange }
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                    invalid= { !!errors.tenantId }
                                />
                                {errors.tenantId && (
                                    <div className="text-danger">{errors.tenantId}</div>
                                )}
                                <small className="form-text text-muted">
                                    Optioneel. Voer een geldige GUID in of laat leeg.
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    <div className="form-actions">
                        <Button 
                            type="submit" 
                            color="primary" 
                            disabled= { loading }
                            className="mr-2"
                        >
                            {loading ? 'Bezig met opslaan...' : 'Opslaan'}
                        </Button>
                        <Button 
                            type="button" 
                            color="secondary" 
                            onClick= { onCancel }
                            disabled= { loading }
                        >
                            Annuleren
                        </Button>
                    </div>
                </Form>
            </div>
        )
    }
}

export default TenantsForm